import { Home } from "lucide-react"

import PeekView from "@/components/peek-view"

interface ReferencedHouseholdProps {
  householdId: string
  householdName?: string
}

export function ReferencedHousehold({ householdId, householdName }: ReferencedHouseholdProps) {
  return (
    <div className="grid w-full items-center gap-2" style={{ gridTemplateColumns: "120px 1fr" }}>
      <div className="inline-flex items-center gap-2">
        <Home className="text-icon size-3.5" strokeWidth={1.5} />
        <span className="text-muted-foreground truncate text-xs">Household</span>
      </div>
      <div className="flex items-center">
        <div className="bg-background flex min-h-6 w-full items-center rounded-md border border-transparent px-2">
          <PeekView recordType="Household" recordId={householdId} label={householdName} size="sm" />
        </div>
      </div>
    </div>
  )
}
